// The numpad decimal key emits "," on most European layouts, so typing 1,5 must not
// silently collapse to 15.
const withDotSeparator = value => value.replace(/,/g, ".");

const createNumberInputGuards = ({ allowNegative }) => {
  const partialNumberPattern = allowNegative ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
  const cssNumberPattern = allowNegative ? /^-?(\d+\.?\d*|\.\d+)$/ : /^(\d+\.?\d*|\.\d+)$/;

  return {
    sanitise: value => {
      const normalised = withDotSeparator(value);

      return partialNumberPattern.test(normalised) ? normalised : normalised.substring(0, normalised.length - 1);
    },
    // A half-typed number like "1." is not a valid CSS number and would silently apply
    // nothing, so it is trimmed; anything else unparseable maps to "".
    toCssNumber: value => {
      const normalised = withDotSeparator(value).replace(/\.$/, "");

      return cssNumberPattern.test(normalised) ? normalised : "";
    },
  };
};

export { createNumberInputGuards };
